// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","return":"_1B5rOGyqI2zj9jrzxRq2Mz","pendingReturn":"_1592oXQyZT5vdC2kDtoUsk","negativeReturn":"rhAfSL0z0tKC8aU1pe-io"};